import {
  CompensationEqualityReportData,
  DynamicPersonnelReportData_Compensation,
} from '~/data/reports';
import { getSumToDecimals } from '~/utils/helper';

export type CompensationEqualityReportEntry = CompensationEqualityReportData & {
  aggregated: {
    salary: number;
    allowance: number;
    benefits: number;
    total: number;
  };
};

export const convertCompensationEqualityReportDataToEntries = (
  data: CompensationEqualityReportData[],
): CompensationEqualityReportEntry[] => {
  const getCurrencySum = getSumToDecimals(2);

  const getMonthlyCompensationsSummary = (
    compensations: DynamicPersonnelReportData_Compensation[],
    frequency: string,
  ) => {
    return compensations
      .filter(({ fCompFrequency }) => fCompFrequency === frequency)
      .reduce((acc, { fCompAmount }) => {
        return getCurrencySum(acc, fCompAmount ?? 0);
      }, 0);
  };

  return data.map((dataRow): CompensationEqualityReportEntry => {
    const salary = dataRow.fEmpSalary?.fSalaryBaseSalary ?? 0;
    const allowance = getMonthlyCompensationsSummary(
      dataRow.fEmpAllow,
      dataRow.fEmpSalary?.fSalaryFrequency,
    );
    const benefits = getMonthlyCompensationsSummary(
      dataRow.fEmpBene,
      dataRow.fEmpSalary?.fSalaryFrequency,
    );

    return {
      ...dataRow,
      aggregated: {
        salary,
        allowance,
        benefits,
        total: getCurrencySum(salary, allowance, benefits),
      },
    };
  });
};
